import { AssetAmount } from "@sundaeswap/asset";
import { useWalletObserver } from "@sundaeswap/wallet-lite";
import { useEffect, useState } from "react";
import { getYieldSdk } from "../graphql/client/yield";
import { useAppConfig } from "./useAppConfig";
const isSatisfied = async (permissions, balance, wallet) => {
    return (await Promise.all(permissions.map(async (permission) => {
        switch (permission.type) {
            case "POLICY":
            case "TOKEN":
            case "LP": // TODO
            case "NFT": {
                for (const [assetId, token] of balance?.entries()) {
                    let satisfies = true;
                    const [policyId = "", assetName = ""] = assetId.split(".");
                    if (permission.policyId !== "*" && policyId !== permission.policyId) {
                        satisfies = false;
                    }
                    if (permission.assetName !== "*" && assetName !== permission.assetName) {
                        satisfies = false;
                    }
                    if (satisfies && Number(token.amount ?? 0) >= Number(permission.minAmount)) {
                        return true;
                    }
                }
                return false;
            }
            case "AND": {
                for (const subPermission of permission.permissions) {
                    if (!(await isSatisfied([subPermission], balance, wallet))) {
                        return false;
                    }
                }
                return true;
            }
            case "OR": {
                for (const subPermission of permission.permissions) {
                    if (await isSatisfied([subPermission], balance, wallet)) {
                        return true;
                    }
                }
                return false;
            }
            case "SUNDAE_YIELD_V2":
                const { getPositions } = await getYieldSdk();
                let positions = await getPositions({
                    beneficiary: wallet,
                });
                const subBalance = new Map();
                for (const p of positions.positions) {
                    for (const { assetID, amount } of p.value) {
                        const existingAmount = subBalance.get(assetID)?.amount ?? 0;
                        // 0 decimal places is ok, because the decimals are factored into the weight in the config
                        subBalance.set(assetID, new AssetAmount(amount + existingAmount, 0));
                    }
                }
                // TODO: this is a bit ugly because we're mixing "token sources" and "voting weight" responsibilities
                // we could refactor this to have two separate notions: where to read token balances from, and how to convert a balance into a voting power
                const subPermissions = permissions.filter((d) => d.type !== "SUNDAE_YIELD_V2");
                return await isSatisfied(subPermissions, subBalance, wallet);
            default:
                return false;
        }
    }))).some((b) => b);
};
export const usePermissions = () => {
    const config = useAppConfig();
    const { balance, stakeAddress } = useWalletObserver();
    const [canVote, setCanVote] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!balance) {
            return;
        }
        (async () => {
            setLoading(true);
            setCanVote(await isSatisfied(config.permissions.voting, balance, stakeAddress));
            setCanCreate(await isSatisfied(config.permissions.proposal, balance, stakeAddress));
            setLoading(false);
        })();
    }, [balance]);
    return {
        isLoading: loading,
        canVote,
        canCreate,
    };
};
//# sourceMappingURL=usePermissions.js.map